'use client'

import { ReactNode } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { ThemeProvider } from '@mui/material/styles'
import lightTheme from '@/app/styles/themes/light.theme'
import compassTheme from '@/app/styles/themes/compass/light.theme'

export default function CustomThemeProvider({
	children,
}: {
	readonly children: ReactNode
}) {
	const { tempBoss2823NewDesign } = useFlags()
	const theme = tempBoss2823NewDesign ? compassTheme : lightTheme

	return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
